import { DetailType } from '../enum/EnumRepository';
import { WorkDetailData } from '../dto/EntityRepository';
import {
  UpdateWorkDetailBulkInfoFileReq,
  UpdateWorkDetailBulkInfoItemReq,
  UpdateWorkDetailBulkInfoReq,
} from '../dto/ReqDtoRepository';

export const toUpdateWorkDetailBulkInfoFileReq = (
  detail: WorkDetailData,
): UpdateWorkDetailBulkInfoFileReq => ({
  uploadFileId: detail.uploadFile.id,
  originUrl: detail.uploadFile.originUrl,
  width: detail.uploadFile.width,
  height: detail.uploadFile.height,
});

/**
 * 부분 수정이어도 현재 값을 같이 보낸다.
 * description 빈 문자열은 null(삭제). videoUrl은 VIDEO일 때만.
 * updateUploadFileReq는 imageChanged이거나 업로드 결과가 있을 때만.
 */
export const toUpdateWorkDetailBulkInfoItemReq = (
  detail: WorkDetailData,
  uploadedFile?: UpdateWorkDetailBulkInfoFileReq,
): UpdateWorkDetailBulkInfoItemReq => {
  const item: UpdateWorkDetailBulkInfoItemReq = {
    id: detail.id,
    description: detail.description === '' ? null : detail.description,
    detailType: detail.detailType,
  };
  if (detail.detailType === DetailType.VIDEO) {
    item.videoUrl = detail.videoUrl || null;
  }
  const fileReq = uploadedFile ?? (detail.imageChanged ? toUpdateWorkDetailBulkInfoFileReq(detail) : undefined);
  if (fileReq) {
    item.updateUploadFileReq = fileReq;
  }
  return item;
};

/** hasChanged인 항목만 모은다. 없으면 null (빈 detailList는 API 실패). */
export const toUpdateWorkDetailBulkInfoReq = (
  workId: string,
  detailList: WorkDetailData[],
  uploadedFileById?: Record<string, UpdateWorkDetailBulkInfoFileReq>,
): UpdateWorkDetailBulkInfoReq | null => {
  const nextList = detailList
    .filter((detail) => detail.hasChanged)
    .map((detail) => toUpdateWorkDetailBulkInfoItemReq(detail, uploadedFileById?.[detail.id]));
  if (nextList.length === 0) return null;
  return { workId, detailList: nextList };
};
